import React from 'react';
import { DivCenter, DivFlexCenter, DivTextAlignCenter, Title } from '../../styles/styles';
import errorGif from '../../assets/4042.gif'
import Draggable from 'react-draggable'
import chroma from 'chroma-js';

function Error() {
    chroma('#00ff31');


    document.addEventListener("DOMContentLoaded", async function(event){
        var url_string = window.location.href;
        var url = new URL(url_string);

        if(url.pathname != '/404')
        {
            document.getElementById('errorMessage')!.innerHTML = 'Oops o ticket não foi encontrado.';
        }
        else{
            document.getElementById('errorMessage')!.innerHTML = 'Oops a página não foi encontrada.';
        }
    });

    return (
        <>
            <div style={{ overflow: 'hidden', height: '100vh', width: '100vw' }}>
                <Draggable>
                    <DivFlexCenter className='mt-5'>
                        <img style={{ userSelect: 'none', pointerEvents: 'none' }} src={errorGif} />
                    </DivFlexCenter>
                </Draggable>

                <DivTextAlignCenter>
                    <Draggable>
                        <Title style={{ userSelect: 'none' }} id='errorMessage'>
                            Oops a página não foi encontrada.
                        </Title>
                    </Draggable>
                    <br />
                    <Draggable>
                        <Title style={{ userSelect: 'none' }}>
                            Tente novamente em alguns instantes.
                        </Title>
                    </Draggable>
                </DivTextAlignCenter>
            </div>
        </>
    );
}

export default Error;
